<input [checked]="element._get('checked')" type="checkbox" [disabled]="element._get('readOnly')">
{{element._get('text')}}